export default __webpack_public_path__ + "static/media/lipstick-clear-summer.771f506e.png";